import { makeStyles } from '@rbx/ui';

const useMarkdownVideoStyles = makeStyles()({
  video: {
    maxWidth: '100%',
    marginBottom: '16px',
    marginTop: '16px',
  },
});

export default useMarkdownVideoStyles;
